import apiClient from "../http/apiClient";
import { RBAC_ENDPOINTS } from "../http/endpoints";

export async function list(params = {}) {
  const response = await apiClient.get(RBAC_ENDPOINTS.permissions, { params });
  return response.data;
}

export const permissionsService = {
  list,
};

export default permissionsService;
